<div class="name">Nome Completo: <span>{{ crew.fullName }}</span></div>
<div class="contract">Base de Contrato: <span>{{ crew.base }}</span></div>
<div class="email">E-mail Atual: <span>{{ crew.email }}</span></div>